import { observer } from 'mobx-react-lite'
import clsx from 'clsx'
import { useSteleBreakpoint } from '@/src/hooks/useBreakpoint'
import ParentsInfoBanner from './banner/ParentsInfoBanner'

export const GameBanner = observer(function GameBanner() {
    const isStele = useSteleBreakpoint()

    if (!isStele) {
        return null
    }

    return (
        <>
            <div
                className={clsx(
                    'z-10 relative pt-12 pb-32 w-full h-215 overflow-hidden shrink-0',
                    'bg-white',
                )}
            >
                <ParentsInfoBanner />
            </div>
        </>
    )
})
